module.exports = __webpack_public_path__ + "media/images/icon__paginationArrows@3x-d9b815459bfed1dde948bfa4488d8783.png";